// extracted by mini-css-extract-plugin
module.exports = {"searchbar":"Searchbar_searchbar__jo466"};